import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PageContainer } from "../Components/Layout/PageContainer";
import { SectionContainer } from "../Components/Layout/SectionContainer";
import { SectionTitle } from "../Components/Layout/Layout";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { getHeaderFooter, getHome } from "../Utils/Services";
import { getPath, isNotNull } from "../Utils/Helpers";
import { LinkButton } from "../Components/Button/LinkButton";

export default function Home() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isReady, setIsReady] = React.useState(false);
  const [hasPageError, setHasPageError] = React.useState(false);
  const [pageErrorCode, setPageErrorCode] = React.useState(null);
  const [campaign, setCampaign] = React.useState({});
  const [header, setHeader] = React.useState([]);
  const [footer, setFooter] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [isCustomCss1, setIsCustomCss1] = React.useState(false);
  const [isCustomCss2, setIsCustomCss2] = React.useState(false);
  const [isCustomCss3, setIsCustomCss3] = React.useState(false);
  const [isCustomCss4, setIsCustomCss4] = React.useState(false);
  const [isCustomCss5, setIsCustomCss5] = React.useState(false);
  const [isCustomCss6, setIsCustomCss6] = React.useState(false);
  const [isCustomCss7, setIsCustomCss7] = React.useState(false);
  const [isCustomCss8, setIsCustomCss8] = React.useState(false);
  const [isCustomCss9, setIsCustomCss9] = React.useState(false);

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    // if (
    //   slug.toLowerCase() !== "aimoment" &&
    //   slug.toLowerCase() !== "celebratingtogether"
    // ) {
    //   window.location.href = "/AIMoment";
    //   return;
    // }

    const headerFooterRes = await getHeaderFooter(slug);
    const res = await getHome(slug);

    if (res.status === 200) {
      setIsCustomCss1(slug.toLowerCase() === "builtforglory");
      setIsCustomCss2(
        slug.toLowerCase() === "greatestrewards2025" ||
          slug.toLowerCase() === "greatestrewards2025-Testing",
      );
      setIsCustomCss3(
        slug.toLowerCase() === "acerday2025-test" ||
          slug.toLowerCase() === "acerday2025",
      );
      setIsCustomCss4(
        slug.toLowerCase() === "fightforhonor1" ||
          slug.toLowerCase() === "fightforhonor",
      );
      setIsCustomCss5(
        slug.toLowerCase() === "celebratingtogether1" ||
          slug.toLowerCase() === "celebratingtogether",
      );
      setIsCustomCss6(
        slug.toLowerCase() === "aimoment1" || 
        slug.toLowerCase() === "aimoment",
      );
      setIsCustomCss7(
        slug.toLowerCase() === "acerdaymv26" ||
          slug.toLowerCase() === "acerdaymv26-test",
      );
      setIsCustomCss8(
        slug.toLowerCase() === "acerdaymv26amd" ||
          slug.toLowerCase() === "acerdaymv26amd-test",
      );
      setIsCustomCss9(
        slug.toLowerCase() === "acerday2026" ||
          slug.toLowerCase() === "acerday2026-test",
      );

      setCampaign(headerFooterRes?.data?.campaign);
      setHeader(headerFooterRes?.data?.headers);
      setFooter(headerFooterRes?.data?.footers);
      setData(res?.data);
      setIsReady(true);
    } else {
      setHasPageError(true);
      setPageErrorCode(res.status);
    }
    setIsLoading(false);
  };

  return (
    <PageContainer
      isLoading={isLoading}
      isReady={isReady}
      slug={slug}
      campaign={campaign}
      header={header}
      footer={footer}
      hasPageError={hasPageError}
      pageErrorCode={pageErrorCode}
    >
      <HeroSlider
        data={data?.hero_sliders}
        sliderContainerClassName={isCustomCss9 ? "bg-[#63BF6A]" : ""}
        customClassName={
          isCustomCss7 || isCustomCss8 || isCustomCss9
            ? "block !w-full !max-w-none !h-auto !aspect-auto !object-contain"
            : ""
        }
        customMobileClassName={
          isCustomCss7 || isCustomCss8 || isCustomCss9
            ? "block !w-full !max-w-none !h-auto !aspect-auto !object-contain"
            : isCustomCss3 || isCustomCss5 || isCustomCss6
            ? "!aspect-auto"
            : ""
        }
      />

      <LeftRightLayout
        data={data?.campaign_details}
        sectionContainerClassName={
          isCustomCss1
            ? "bg-[#0E2545] pb-10 !px-0"
            : isCustomCss2
              ? "bg-[#006d68] !px-0"
              : isCustomCss3
                ? "bg-[#0b8769] pb-10 !px-0"
                : isCustomCss4
                  ? "bg-[#000000] pb-10 !px-0"
                : isCustomCss7 || isCustomCss8 || isCustomCss9
                  ? "!px-0 sm:-mt-px overflow-hidden"
                  : isCustomCss5 || isCustomCss6
                    ? "!px-0"
                    : ""
        }
        containerClassName={
          isCustomCss1 || isCustomCss3 || isCustomCss4
            ? ""
            : isCustomCss2 ||
                isCustomCss5 ||
                isCustomCss6 ||
                isCustomCss7 || isCustomCss8 || isCustomCss9
              ? "!max-w-none"
              : "py-10 sm:flex-row gap-8"
        }
        contentClassName={isCustomCss2 ? "hidden" : ""}
        imageClassName={isCustomCss7||isCustomCss8||isCustomCss9 ? "block w-full max-w-none" : ""}
        mobileImage={
          isCustomCss7 ? "/images/acerday-mv26-mobile-rewards.jpg" : ""
        }
        isCustomCss={
          isCustomCss1 ||
          isCustomCss2 ||
          isCustomCss3 ||
          isCustomCss4 ||
          isCustomCss5 ||
          isCustomCss6 ||
          isCustomCss7 || 
          isCustomCss8 ||
          isCustomCss9
        }
        buttonContainerClassName={
          isCustomCss1 || isCustomCss3 || isCustomCss4
            ? "justify-center"
            : isCustomCss5
              ? "justify-center -mt-[12%] sm:-mt-[10%]"
              : ""
        }
        buttonPrimaryClassName={
          isCustomCss1
            ? "!bg-[#E39E41] !text-white"
            : isCustomCss3
              ? "!bg-[#83B14F] !text-white"
              : isCustomCss4
                ? "!bg-[#0094FF] !text-white"
                : isCustomCss5
                  ? "!bg-[#d71d26] !text-white !py-2 sm:!py-3 !px-4 sm:!px-5"
                  : ""
        }
        buttonSecondaryClassName={
          isCustomCss1
            ? "!bg-[#385DA3] !text-white"
            : isCustomCss3
              ? "!bg-[#D1A51E] !text-white"
              : isCustomCss4
                ? "!bg-[#8D2AF1] !text-white"
                : isCustomCss5
                  ? "!bg-[#5cbd2c] !text-white !py-2 sm:!py-3 !px-4 sm:!px-5"
                  : ""
        }
        // sectionContainerClassName="!p-0"
        // containerClassName="gap-0"
        // contentClassName="py-4 px-16"
      />

      {data?.redemptionSteps?.length > 0 && (
        <TopBottomLayout
          sectionContainerClassName={
            isCustomCss1
              ? "bg-[#375385]"
              : isCustomCss2
                ? "bg-[#5c9c8f]"
                : isCustomCss3
                  ? "bg-[#48a58f]"
                  : isCustomCss5
                    ? "bg-[#fbf0da]"
                    : isCustomCss6
                      ? "bg-[#f9eee5]"
                      : isCustomCss9
                        ? "bg-[linear-gradient(to_bottom,#ffffff_0%,#eef9f0_18%,#c8ecc5_52%,#a8d97f_100%)]"
                        : isCustomCss8
                          ? "bg-[#b7d984]"
                          : isCustomCss7
                            ? "bg-[#c7eef2]"
                            : ""
          }
          textClassName={
            isCustomCss1
              ? "!text-white"
              : isCustomCss5
                ? "!text-[#672a0c]"
                : isCustomCss6
                  ? "!text-[#8c5a3d]"
                  : isCustomCss8 || isCustomCss9
                    ? "!text-[#006b4b] !font-extrabold"
                  : isCustomCss7
                    ? "!text-[#c044d0] !font-extrabold"
                    : ""
          }
          containerClassName={
            isCustomCss7 || isCustomCss8 || isCustomCss9
              ? `py-14 sm:py-14 space-y-4 sm:space-y-10 ${
                  isCustomCss8
                    ? "min-[1537px]:py-[clamp(72px,4.4vw,112px)] min-[1537px]:space-y-[clamp(40px,2.6vw,66px)]"
                    : ""
                }`
              : ""
          }
          topImage={
            isCustomCss7 ? "/images/acerday-mv26-contest-banner.png" : ""
          }
          topImageClassName={
            isCustomCss7 || isCustomCss8
              ? "mx-auto w-full max-w-[min(92vw,896px)] object-contain"
              : ""
          }
          titleClassName={
            isCustomCss8 || isCustomCss9
              ? "!text-[#006b4b] !text-[clamp(14px,4.2vw,54px)] min-[1537px]:!text-[clamp(54px,3.2vw,82px)] !leading-none whitespace-nowrap"
              : isCustomCss7
              ? "!text-[clamp(14px,4.2vw,54px)] !leading-none whitespace-nowrap"
              : ""
          }
          subtitleClassName={
            isCustomCss8 || isCustomCss9
              ? "!text-[#006b4b] !text-[clamp(7px,2.4vw,28px)] min-[1537px]:!text-[clamp(28px,1.6vw,42px)] !font-bold !leading-none whitespace-nowrap"
              : isCustomCss7 
              ? "!text-[clamp(7px,2.4vw,28px)] !font-bold !leading-none whitespace-nowrap"
              : ""
          }
          title={isCustomCss3 ? "" :isCustomCss7 ? "How to Redeem Reward & Enter Contest" : "How to Redeem"}
          subtitle={
            isCustomCss3
              ? ""
              : isCustomCss7 
                ? "Exciting rewards and a pair of tickets to Busan, South Korea await you!"
                :isCustomCss8
                  ? "Purchase select Acer models powered by AMD and get rewarded!"
                  : "Redeem exciting gifts when you participate in our campaign"
          }
        >
          <RedemptionSteps
            slug={slug}
            data={data.redemptionSteps}
            containerClassName={
              isCustomCss9
                ? "bg-[#E5F2E1] rounded-xl overflow-hidden shadow-lg border border-[#b4cf9a]"
                : isCustomCss7 || isCustomCss8
                ? "bg-[#bd45bd] rounded-xl overflow-hidden shadow-lg"
                : isCustomCss5 || isCustomCss6
                  ? "bg-white h-full rounded-xl py-6 px-4 shadow-lg"
                  : ""
            }
            stepClassName={
              isCustomCss1
                ? "!bg-[#385DA3]"
                : isCustomCss3
                  ? "!bg-[#e5d436]"
                  : isCustomCss7 || isCustomCss8 || isCustomCss9
                    ? "!bg-transparent !p-0 !w-auto !h-auto"
                    : isCustomCss5
                      ? "!rounded-full !bg-white !border-2 !border-[#db7800]"
                      : isCustomCss6
                        ? "!bg-white !p-0 !w-auto !h-auto"
                        : ""
            }
            stepTextClassName={
              isCustomCss1 || isCustomCss3
                ? "!text-white"
                : isCustomCss9
                 ? "!text-white !text-[clamp(13px,4.2vw,18px)] md:!text-[clamp(25px,2.3vw,32px)] min-[1537px]:!text-[clamp(32px,1.9vw,48px)] font-bold !py-[clamp(3px,0.55vw,6px)] md:!py-[clamp(6px,0.7vw,10px)] min-[1537px]:!py-[clamp(8px,0.7vw,14px)]"
                : isCustomCss8
                  ? "!text-[clamp(18px,6vw,26px)] md:!text-[clamp(36px,3.3vw,46px)] min-[1537px]:!text-[clamp(46px,2.7vw,68px)] !text-white font-bold"
                : isCustomCss7
                  ? "!text-[clamp(18px,6vw,26px)] md:!text-[clamp(36px,3.3vw,46px)] !text-white font-bold"
                  : isCustomCss5
                    ? "!text-[#672a0c] font-bold"
                    : isCustomCss6
                      ? "!text-xl  !text-[#aa6d41] font-bold"
                      : ""
            }
            titleTextClassName={
              isCustomCss1 || isCustomCss3
                ? "!text-white"
                : isCustomCss9
                  ? "!text-[#6e2b13] !text-[clamp(11px,3.5vw,15px)] md:!text-[clamp(18px,1.55vw,22px)] min-[1537px]:!text-[clamp(22px,1.35vw,34px)] !font-bold uppercase leading-tight pb-[clamp(4px,0.5vw,9px)] min-[1537px]:pb-[clamp(9px,0.7vw,18px)]"
                : isCustomCss8
                  ? "!text-white !text-[clamp(11px,3.5vw,15px)] md:!text-[clamp(18px,1.55vw,22px)] min-[1537px]:!text-[clamp(22px,1.35vw,34px)] !font-bold uppercase leading-tight pb-[clamp(4px,0.5vw,9px)] min-[1537px]:pb-[clamp(9px,0.7vw,18px)]"
                : isCustomCss7
                  ? "!text-white !text-[clamp(11px,3.5vw,15px)] md:!text-[clamp(18px,1.55vw,22px)] !font-bold uppercase leading-tight pb-[clamp(4px,0.5vw,9px)]"
                  : isCustomCss5
                    ? "!text-[#672a0c]"
                    : isCustomCss6
                      ? "!text-[#6e2b13]"
                      : ""
            }
            textClassName={
              isCustomCss1 || isCustomCss3
                ? "!text-white"
                : isCustomCss2
                  ? "!text-gray-700"
                  : isCustomCss7
                    ? "!text-white !text-[clamp(8px,2.9vw,12px)] md:!text-[15px] min-[958px]:!text-[16px] min-[1015px]:!text-[17px] min-[1024px]:!text-[17px] min-[1078px]:!text-[18px] min-[1142px]:!text-[18.5px] min-[1206px]:!text-[18px] min-[2000px]:!text-[17px] leading-snug"
                    : isCustomCss5
                      ? "!text-[#672a0c]"
                      : isCustomCss6
                        ? "!text-[#6e2b13]"
                        : isCustomCss8
                        ? "!text-white !text-[clamp(8px,2.9vw,13px)] min-[958px]:!text-[15px] min-[1537px]:!text-[clamp(16.2px,1vw,26px)] leading-snug"
                        : isCustomCss9
                         ? "!text-[#6e2b13] !text-[clamp(8px,2.9vw,13px)] min-[958px]:!text-[14px] min-[1037px]:!text-[16.2px] min-[1537px]:!text-[clamp(16.2px,1vw,26px)] leading-snug"
                        : ""
            }
            buttonClassName={isCustomCss1 ? "!bg-[#B62D89] !text-white" : ""}
            buttonPrimaryClassName={
              isCustomCss9 
                ? "!bg-[#006f45] hover:!bg-[#006f45] !text-white !font-bold !uppercase !text-xs md:!text-[clamp(18px,1.25vw,22px)] min-[1537px]:!text-[clamp(22px,1.35vw,34px)] !leading-none !rounded-md min-[1537px]:!rounded-lg !py-1 md:!py-[clamp(6px,0.55vw,10px)] min-[1537px]:!py-[clamp(10px,0.7vw,18px)] !px-3 md:!px-[clamp(12px,1vw,18px)] min-[1537px]:!px-[clamp(18px,1.1vw,28px)] !w-auto !min-w-[88px] md:!w-full md:!min-w-0 md:!max-w-none !justify-center !mx-auto !whitespace-nowrap"
              :isCustomCss8 
                ? "!bg-[#3fb871] hover:!bg-[#3fb871] !text-white !font-bold !uppercase !text-xs md:!text-[clamp(18px,1.25vw,22px)] min-[1537px]:!text-[clamp(22px,1.35vw,34px)] !leading-none !rounded-md min-[1537px]:!rounded-lg !py-1 md:!py-[clamp(6px,0.55vw,10px)] min-[1537px]:!py-[clamp(10px,0.7vw,18px)] !px-3 md:!px-[clamp(12px,1vw,18px)] min-[1537px]:!px-[clamp(18px,1.1vw,28px)] !w-auto !min-w-[88px] md:!w-full md:!min-w-0 md:!max-w-none !justify-center !mx-auto !whitespace-nowrap"
              : isCustomCss7
                ? "!bg-[#3fb871] hover:!bg-[#3fb871] !text-white !font-bold !uppercase !text-xs md:!text-[clamp(18px,1.25vw,22px)] !leading-none !rounded-md !py-1 md:!py-[clamp(6px,0.55vw,10px)] !px-3 md:!px-[clamp(12px,1vw,18px)] !w-auto !min-w-[88px] md:!w-full md:!min-w-0 md:!max-w-none !justify-center !mx-auto !whitespace-nowrap"
                : isCustomCss3
                  ? "!bg-[#83B14F] !text-white"
                  : isCustomCss5
                    ? "!bg-[#d71d26] !text-white"
                    : isCustomCss6
                      ? "!bg-[#8c5a3d] !text-white"
                      : ""
            }
            buttonSecondaryClassName={
              isCustomCss9
                ? "!bg-[#006f45] hover:!bg-[#006f45] !text-white !font-bold !uppercase !text-xs md:!text-[clamp(18px,1.25vw,22px)] min-[1537px]:!text-[clamp(22px,1.35vw,34px)] !leading-none !rounded-md min-[1537px]:!rounded-lg !py-1 md:!py-[clamp(6px,0.55vw,10px)] min-[1537px]:!py-[clamp(10px,0.7vw,18px)] !px-3 md:!px-[clamp(12px,1vw,18px)] min-[1537px]:!px-[clamp(18px,1.1vw,28px)] !w-auto !min-w-[120px] md:!w-full md:!min-w-0 md:!max-w-none !justify-center !mx-auto !whitespace-nowrap"
              :isCustomCss8
                ? "!bg-[#3fb871] hover:!bg-[#3fb871] !text-white !font-bold !uppercase !text-xs md:!text-[clamp(18px,1.25vw,22px)] min-[1537px]:!text-[clamp(22px,1.35vw,34px)] !leading-none !rounded-md min-[1537px]:!rounded-lg !py-1 md:!py-[clamp(6px,0.55vw,10px)] min-[1537px]:!py-[clamp(10px,0.7vw,18px)] !px-3 md:!px-[clamp(12px,1vw,18px)] min-[1537px]:!px-[clamp(18px,1.1vw,28px)] !w-auto !min-w-[120px] md:!w-full md:!min-w-0 md:!max-w-none !justify-center !mx-auto !whitespace-nowrap"
              : isCustomCss7
                ? "!bg-[#3fb871] hover:!bg-[#3fb871] !text-white !font-bold !uppercase !text-xs md:!text-[clamp(18px,1.25vw,22px)] !leading-none !rounded-md !py-1 md:!py-[clamp(6px,0.55vw,10px)] !px-3 md:!px-[clamp(12px,1vw,18px)] !w-auto !min-w-[120px] md:!w-full md:!min-w-0 md:!max-w-none !justify-center !mx-auto !whitespace-nowrap"
                : isCustomCss3
                  ? "!bg-[#D1A51E] !text-white"
                  : isCustomCss5
                    ? "!bg-[#d71d26] !text-white"
                    : isCustomCss6
                      ? "!bg-[#8c5a3d] !text-white"
                      : ""
            }
            isCustomCss5={isCustomCss5 || isCustomCss6}
            isCustomCss7={isCustomCss7 || isCustomCss8}
            isCustomCss8={isCustomCss8}
            isCustomCss9={isCustomCss9}
          />
        </TopBottomLayout>
      )}

      {data?.rewards && (
        <TopBottomLayout
          sectionContainerClassName={
            isCustomCss1
              ? "bg-[#000116] pb-10 !px-0"
              : isCustomCss2 ||
                  isCustomCss3 ||
                  isCustomCss4 ||
                  isCustomCss7 ||
                  isCustomCss8 ||
                  isCustomCss9
                ? "!px-0"
                : ""
          }
          containerClassName={
            isCustomCss1 ||
            isCustomCss2 ||
            isCustomCss3 ||
            isCustomCss4 ||
            isCustomCss7 ||
            isCustomCss8 ||
            isCustomCss9
              ? "!py-0 !max-w-none"
              : "!space-y-4"
          }
          title={data?.rewards?.section_title}
          subtitle={data?.rewards?.section_description}
        >
          <Rewards
            slug={slug}
            data={data?.rewards?.rewards}
            buttonClassName={
              isCustomCss1 ? "!bg-[#72C3EE] !text-[#000116]" : ""
            }
            hideButton={
              isCustomCss3 ||
              isCustomCss4 ||
              isCustomCss5 ||
              isCustomCss6 ||
              isCustomCss7 ||
              isCustomCss8 ||
              isCustomCss9
            }
          />
        </TopBottomLayout>
      )}

      {data?.whatsNew?.type === "image-only" ? (
        <Hero
          data={data.whatsNew}
          className={`${
            isCustomCss1 ||
            isCustomCss2 ||
            isCustomCss3 ||
            isCustomCss4 ||
            isCustomCss5 ||
            isCustomCss6 ||
            isCustomCss7 ||
            isCustomCss8 ||
            isCustomCss9
              ? "!aspect-auto"
              : ""
          } !object-contain`}
        />
      ) : data?.whatsNew?.type === "image-text" ? (
        <LeftRightLayout
          data={data.whatsNew}
          // containerClassName="py-24"
        />
      ) : null}
    </PageContainer>
  );
}

const Hero = ({ data, className, customMobileClassName }) => {
  return (
    <div className="overflow-hidden leading-none">
      {data?.desktop_image && (
        <img
          className={`!hidden sm:!block block w-full aspect-video object-cover object-center ${className}`}
          src={data.desktop_image}
          alt={data?.alt_text}
        />
      )}
      {data?.mobile_image && (
        <img
          className={`sm:!hidden block w-full aspect-bannerMobile object-cover object-center ${className} ${customMobileClassName}`}
          src={data.mobile_image}
          alt={data?.alt_text}
        />
      )}
    </div>
  );
};

const HeroSlider = ({
  data,
  sliderContainerClassName,
  customClassName,
  customMobileClassName,
}) => {
  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} !right-3 sm:!right-6 !flex !justify-center !items-center !w-8 !h-8 sm:!w-12 sm:!h-12 !rounded-full !bg-[rgba(255,255,255,0.30)]`}
        style={{ ...style }}
        onClick={onClick}
      >
        <FaChevronRight className={`text-base sm:text-xl text-white`} />
      </div>
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} !left-3 sm:!left-6 !flex !justify-center !items-center !w-8 !h-8 sm:!w-12 sm:!h-12 !rounded-full !bg-[rgba(255,255,255,0.30)]`}
        style={{ ...style }}
        onClick={onClick}
      >
        <FaChevronLeft className={`text-base sm:text-xl text-white`} />
      </div>
    );
  }

  const settings = {
    dots: data.length > 1,
    infinite: data?.length > 1,
    speed: 500,
    autoplaySpeed: 5000,
    autoplay: data?.length > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: data?.length > 1 ? <NextArrow /> : null,
    prevArrow: data?.length > 1 ? <PrevArrow /> : null,
  };

  return (
    <div className={sliderContainerClassName}>
      <Slider {...settings}>
        {data?.length > 0 &&
          data.map((item, index) => (
            <Hero
              key={index}
              data={item}
              className={customClassName}
              customMobileClassName={customMobileClassName}
            />
          ))}
      </Slider>
    </div>
  );
};

const RedemptionSteps = ({
  slug,
  data,
  containerClassName,
  stepClassName,
  stepTextClassName,
  titleTextClassName,
  textClassName,
  buttonClassName,
  buttonPrimaryClassName,
  buttonSecondaryClassName,
  isCustomCss5,
  isCustomCss7,
  isCustomCss8,
  isCustomCss9,
}) => {
  return (
    <>
      {data?.length > 0 && (
        <div
          className={
            isCustomCss9
              ? "grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_clamp(22px,2.2vw,34px)_minmax(0,1fr)_clamp(22px,2.2vw,34px)_minmax(0,1fr)] justify-items-center gap-y-4 md:gap-y-0 gap-x-[clamp(9px,1.5vw,26px)] md:gap-x-0 w-full max-w-[clamp(240px,76vw,290px)] md:max-w-[clamp(660px,74vw,760px)] min-[1441px]:grid-cols-[minmax(0,1fr)_clamp(40px,2.4vw,62px)_minmax(0,1fr)_clamp(40px,2.4vw,62px)_minmax(0,1fr)] min-[1441px]:max-w-[clamp(860px,48vw,1220px)] mx-auto"
              : isCustomCss7 || isCustomCss8
              ? `grid grid-cols-1 md:grid-cols-3 justify-items-center gap-y-4 md:gap-y-0 gap-x-[clamp(9px,1.5vw,26px)] md:gap-x-[clamp(22px,2.2vw,34px)] w-full max-w-[clamp(240px,76vw,290px)] md:max-w-[clamp(660px,74vw,760px)] ${
                  isCustomCss8
                    ? "min-[1537px]:max-w-[clamp(860px,48vw,1220px)] min-[1537px]:gap-x-[clamp(40px,2.4vw,62px)]"
                    : ""
                } mx-auto`
              : "flex flex-row flex-wrap justify-evenly gap-8"
          }
        >
          {data.map((item, index) => {
            const custom9StepHeaderClassName =
              ["bg-[#ffd72d]", "bg-[#ff7433]", "bg-[#5a95cf]"][index] ||
              "bg-[#006f45]";

            return (
              <React.Fragment key={index}>
              <div
                className={
                  isCustomCss7 || isCustomCss8 || isCustomCss9
                    ? `w-full max-w-[clamp(220px,76vw,270px)] md:max-w-[clamp(190px,20vw,230px)] ${
                        isCustomCss9
                          ? "min-[1441px]:max-w-[clamp(260px,14.6vw,370px)]"
                          : isCustomCss8
                          ? "min-[1537px]:max-w-[clamp(260px,14.6vw,370px)] min-[1537px]:gap-[clamp(28px,1.8vw,46px)]"
                          : ""
                      } flex flex-col gap-3 md:gap-[clamp(18px,1.8vw,28px)] items-center`
                    : "w-full sm:w-1/4 flex flex-col gap-4 items-center"
                }
              >
                <div className={isCustomCss9 ? "relative w-full" : "contents"}>
                <div
                  className={`w-full flex flex-col items-center ${containerClassName} ${isCustomCss5 && index === data.length - 1 ? "mb-12" : ""} ${isCustomCss7 && index === data.length - 1 ? "md:mb-12" : ""} ${isCustomCss8 && index === data.length - 1 ? "md:mb-12" : ""} ${isCustomCss9 && index === data.length - 1 ? "md:mb-12" : ""}`}
                >
                  {isCustomCss7 || isCustomCss8 || isCustomCss9 ? (
                    <>
                      <div className={`w-full ${
                        isCustomCss9 ? custom9StepHeaderClassName : "bg-[#a818a8]"
                      } px-[clamp(12px,4vw,24px)] md:px-[clamp(14px,1.4vw,24px)] ${
                        isCustomCss8
                          ? "min-[1537px]:px-[clamp(24px,1.5vw,38px)] min-[1537px]:pt-[clamp(8px,0.65vw,16px)] min-[1537px]:pb-[clamp(8px,0.65vw,16px)]"
                          : ""
                      } pt-1 pb-1 flex flex-col justify-start items-center`}>
                        <div
                          className={`w-12 h-12 rounded-lg bg-primary-50 flex justify-center items-center ${stepClassName} ${stepTextClassName}`}
                        >
                          {item.step}
                        </div>
                        {item.title && !isCustomCss9 ? (
                          <p
                            className={`text-xl font-bold text-gray-900 text-center max-w-[92%] ${index === 2 ? "whitespace-nowrap md:whitespace-normal" : ""} ${titleTextClassName}`}
                          >
                            {index === 2?(<>GET<span className="md:hidden"> </span><br className="hidden md:block"/>REWARDED!</>):(item.title

                            )}
                          </p>
                        ) : null}
                      </div>
                      {isCustomCss9 ? (
                        <div
                          className="html-content w-full md:flex-1 flex flex-col justify-start items-center text-center"
                        >
                          {item.title ? (
                            <div className="w-full flex justify-center items-center bg-[#ECF6ED] px-[clamp(6px,1.1vw,18px)] md:px-[clamp(14px,1.4vw,24px)] min-[1537px]:px-[clamp(24px,1.5vw,38px)] py-[clamp(4px,0.5vw,8px)] md:min-h-[clamp(60px,6.3vw,86px)] min-[1441px]:min-h-0 min-[1441px]:py-2">
                              <p
                                className={`text-xl font-bold text-gray-900 text-center max-w-[92%] !m-0 !p-0 ${index === 2 ? "whitespace-nowrap md:whitespace-normal" : ""} ${titleTextClassName}`}
                              >
                                {index === 2 ? (
                                  <>
                                    GET<span className="md:hidden"> </span>
                                    <br className="hidden md:block" />
                                    REWARDED!
                                  </>
                                ) : (
                                  item.title
                                )}
                              </p>
                            </div>
                          ) : null}
                          {item.description ? (
                            <div
                              className={`w-full md:flex-1 flex justify-center items-start bg-[#e2f2df] px-[clamp(6px,1.1vw,18px)] md:px-[clamp(14px,1.4vw,24px)] min-[1537px]:px-[clamp(24px,1.5vw,38px)] pt-[clamp(18px,1.4vw,30px)] ${
                                index === 1
                                  ? "pb-[clamp(22px,1.8vw,38px)] md:pb-[calc(clamp(22px,1.8vw,38px)+2.75em)] min-[1537px]:pb-[calc(clamp(38px,1.8vw,70px)+2.75em)]"
                                  : index === 2
                                    ? "pb-[clamp(22px,1.8vw,38px)] md:pb-[calc(clamp(22px,1.8vw,38px)+1.375em)] min-[1537px]:pb-[calc(clamp(38px,1.8vw,70px)+1.375em)]"
                                    : "pb-[clamp(22px,1.8vw,38px)] min-[1537px]:pb-[clamp(38px,1.8vw,70px)]"
                              } text-base text-gray-500 text-center ${textClassName}`}
                              dangerouslySetInnerHTML={{ __html: item.description }}
                            />
                          ) : null}
                        </div>
                      ) : item.description ? (
                        <p
                          className={`html-content w-full md:flex-1 flex flex-col justify-start items-center bg-[#bd45bd] px-[clamp(6px,1.1vw,18px)] md:px-[clamp(14px,1.4vw,24px)] ${
                            isCustomCss8
                              ? "min-[1537px]:px-[clamp(24px,1.5vw,38px)] min-[1537px]:pt-[clamp(14px,0.9vw,24px)]"
                              : ""
                          } pt-[clamp(6px,0.5vw,11px)] ${
                            isCustomCss8
                              ? index === 0
                                ? "pb-[clamp(6px,0.5vw,11px)] md:pb-[calc(clamp(6px,0.5vw,11px)+1.375em)]"
                                : index === 1
                                  ? "pb-[calc(clamp(6px,0.5vw,11px)+1.375em)] md:pb-[calc(clamp(6px,0.5vw,11px)+4.125em)]"
                                  : "pb-[calc(clamp(6px,0.5vw,11px)+1.375em)] md:pb-[calc(clamp(6px,0.5vw,11px)+2.75em)]"
                              : index === 0
                                ? "pb-[calc(clamp(6px,0.5vw,11px)+1.375em)]"
                                : index === 1
                                  ? "pb-[calc(clamp(6px,0.5vw,11px)+1.375em)] md:pb-[calc(clamp(6px,0.5vw,11px)+4.125em)]"
                                  : "pb-[clamp(6px,0.5vw,11px)]"
                          } text-base text-gray-500 text-center ${textClassName}`}
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                      ) : null}
                    </>
                  ) :
                   (
                    <>
                      <div
                        className={`w-12 h-12 rounded-lg bg-primary-50 py-2 px-3 flex justify-center items-center ${stepClassName} ${stepTextClassName}`}
                      >
                        {item.step}
                      </div>
                      {item.title ? (
                        <p
                          className={`text-xl font-bold text-gray-900 text-center ${titleTextClassName}`}
                        >
                          {item.title}
                        </p>
                      ) : null}
                      {item.description ? (
                        <p
                          className={`html-content text-base text-gray-500 text-center ${textClassName}`}
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                      ) : null}
                    </>
                  )}
                </div>
                </div>
                <div className={isCustomCss7 || isCustomCss8 || isCustomCss9 ? "mt-auto w-full" : "mt-auto"}>
                  {item.button_type !== "no" ? (
                    <LinkButton
                      primary={item.button_type === "primary"}
                      secondary={item.button_type === "secondary"}
                      className={
                        (item.button_type === "primary" &&
                          buttonPrimaryClassName) ||
                        (item.button_type === "secondary" &&
                          buttonSecondaryClassName) ||
                        buttonClassName
                      }
                      label={item.button_title}
                      link={item.button_link}
                    />
                  ) : null}
                </div>
                {isCustomCss9 && index < data.length - 1 ? (
                  <div className="pointer-events-none flex justify-center md:hidden">
                    <span className="h-0 w-0 border-x-[clamp(8px,2vw,12px)] border-t-[clamp(12px,2.4vw,18px)] border-x-transparent border-t-[#006f45]" />
                  </div>
                ) : null}
              </div>
              {isCustomCss9 && index < data.length - 1 ? (
                <div className="pointer-events-none relative hidden h-full items-center justify-center md:-top-5 md:flex">
                  <span className="h-0 w-0 border-y-[clamp(8px,0.9vw,12px)] border-l-[clamp(12px,1vw,18px)] border-y-transparent border-l-[#006f45]" />
                </div>
              ) : null}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </>
  );
};

const Rewards = ({ slug, data, buttonClassName, hideButton }) => {
  return (
    <>
      {data?.length > 0 && (
        <div className="flex flex-row flex-wrap justify-evenly -mx-2">
          {data.map((item, index) => {
            return (
              <div
                key={index}
                className={`w-full ${
                  data?.length > 4 ? "sm:w-1/4" : `sm:w-1/${data?.length}`
                } flex flex-col gap-4 items-center px-2 py-6`}
              >
                <img className="" src={item.image} alt="" />
                {item.description ? (
                  <p
                    className="html-content text-base text-gray-500 text-center"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                ) : null}
              </div>
            );
          })}
        </div>
      )}
      {!hideButton && (
        <div className="flex justify-center items-center">
          <LinkButton
            primary
            className={buttonClassName}
            label="Redeem Now"
            link={getPath(slug, "/participate")}
          />
        </div>
      )}
    </>
  );
};

const TopBottomLayout = ({
  children,
  sectionContainerClassName,
  containerClassName,
  title,
  subtitle,
  textClassName,
  titleClassName,
  subtitleClassName,
  topImage,
  topImageClassName,
}) => {
  return (
    <SectionContainer
      sectionContainerClassName={sectionContainerClassName}
      containerClassName={`py-10 space-y-8 ${containerClassName}`}
    >
      {topImage ? (
        <img
          className={topImageClassName}
          src={topImage}
          alt=""
        />
      ) : null}
      <SectionTitle
        title={title}
        subtitle={subtitle}
        titleClassName={`${textClassName} ${titleClassName}`}
        subtitleClassName={`${textClassName} ${subtitleClassName}`}
      />
      {children}
    </SectionContainer>
  );
};

const LeftRightLayout = ({
  data,
  sectionContainerClassName,
  containerClassName,
  contentClassName,
  imageClassName = "",
  mobileImage,
  isCustomCss,
  buttonContainerClassName,
  buttonPrimaryClassName,
  buttonSecondaryClassName,
}) => {
  if (data)
    return (
      <SectionContainer
        sectionContainerClassName={sectionContainerClassName}
        containerClassName={`flex flex-col justify-center items-center ${containerClassName}`}
      >
        {(data?.section_image || data?.image) && (
          <div className={`w-full ${isCustomCss ? "" : "sm:w-1/2"}`}>
            <img
              className={`mx-auto ${mobileImage ? "hidden sm:block" : ""} ${imageClassName}`}
              src={data?.section_image || data?.image}
              alt=""
            />
            {mobileImage ? (
              <img
                className={`mx-auto block sm:hidden ${imageClassName}`}
                src={mobileImage}
                alt=""
              />
            ) : null}
          </div>
        )}
        <div
          className={`w-full ${
            isCustomCss ? "" : "sm:w-1/2"
          } space-y-8 ${contentClassName}`}
        >
          <SectionTitle
            title={data?.section_title || data?.primary_title}
            subtitle={data?.primary_description || data?.secondary_title}
            titleClassName="!text-4xl !text-left"
            subtitleClassName="!text-left"
          />
          {(data?.secondary_description || data?.description) && (
            <p
              className="html-content text-base"
              dangerouslySetInnerHTML={{
                __html: data?.secondary_description || data?.description,
              }}
            />
          )}
          {(data?.primary_button_text || data?.secondary_button_text) && (
            <div className={`flex flex-row gap-2 ${buttonContainerClassName}`}>
              {isNotNull(data?.primary_button_text) && (
                <LinkButton
                  primary={!buttonPrimaryClassName}
                  className={buttonPrimaryClassName}
                  label={data.primary_button_text}
                  link={data.primary_button_link}
                />
              )}

              {isNotNull(data?.secondary_button_text) && (
                <LinkButton
                  secondary={!buttonSecondaryClassName}
                  className={buttonSecondaryClassName}
                  label={data.secondary_button_text}
                  link={data.secondary_button_link}
                />
              )}
            </div>
          )}
        </div>
      </SectionContainer>
    );
};
